/* Phone sticky buy bar for the PDP hero (sections/kkumi-product-hero.liquid,
   setting `sticky_bar`; PDP hero v3 handoff, phase 6).

   Under 1000px wide, while the main Add to cart is off screen
   (IntersectionObserver), a bar pinned to the bottom shows the chosen
   options' photos, the total (and the quantity from 2) and one button.
   With `sticky_bar_from_load` (data-from-load, on by default; owner,
   2026-10-28) it shows from page load, while the button is still further
   down; off, it waits until the button has scrolled off the top (the owner's
   2026-10-05 behaviour).

   The button never decides anything itself. It shows what the main button
   shows (its label without the price, disabled / busy, "Choose [option]",
   "Checking availability…", "Couldn't check. Try again") and presses it, so
   the add, the missing-choice guard and the retry all run their usual way.
   On a sold-out pick it shows and presses the Notify me button instead.

   While it shows, body.kk-pdp-bar-on hides the club launcher and the promo
   card / re-open tab (kkumi-pdp-bar.css) and pads the page bottom so the
   footer can scroll clear of it. Not inside a dialog. */
(function () {
  function textOf(n) { return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
  // A child the main button currently shows (CSS hides the others).
  function shown(n) { return !!n && n.getClientRects().length > 0; }
  // Idempotent writes (MutationObserver feedback-loop rule, FRONTEND.md).
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function setAttr(node, name, value) {
    if (!node) return;
    if (value == null) { if (node.hasAttribute(name)) node.removeAttribute(name); }
    else if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function bind(bar) {
    if (bar.dataset.kkBarBound === '1') return;
    var root = bar.closest('product-info');
    // A copy of the hero inside a dialog has its own button in view.
    if (!root || bar.closest('modal-dialog, dialog')) { bar.remove(); return; }
    bar.dataset.kkBarBound = '1';
    var el = window.KKEl;
    var copy = bar.dataset;
    var btn = bar.querySelector('[data-kk-bar-btn]');
    var mq = window.matchMedia('(max-width: 999px)');
    var ctaInView = true;
    var frame = 0;

    function main() { return root.querySelector('.kk-pdp-atc-btn'); }
    function notifyBtn() {
      var slot = root.querySelector('[data-kk-notify-slot]');
      return slot && !slot.hidden ? slot.querySelector('button') : null;
    }

    function state() {
      var nb = notifyBtn();
      if (nb && (!main() || main().disabled)) return { mode: 'notify', label: textOf(nb.querySelector('span')) || textOf(nb) };
      var b = main();
      if (!b) return null;
      var busy = b.getAttribute('aria-busy') === 'true' || b.classList.contains('loading');
      var parts = [];
      Array.prototype.forEach.call(b.children, function (c) {
        if (c.classList.contains('kk-pdp-atc-price') || c.tagName.toLowerCase() === 'svg') return;
        if (shown(c) && textOf(c)) parts.push(textOf(c));
      });
      return {
        mode: 'atc',
        label: parts.join(' '),
        disabled: b.disabled || busy,
        busy: busy || root.classList.contains('kk-checking'),
        prompt: root.classList.contains('kk-choice-missing') && !b.disabled,
        failed: root.classList.contains('kk-check-failed')
      };
    }

    function paintThumbs() {
      var box = bar.querySelector('[data-kk-bar-thumbs]');
      var picks = [];
      Array.prototype.forEach.call(root.querySelectorAll('fieldset.var-block'), function (fs) {
        var vs = fs.closest('variant-selects');
        if (vs && vs.style.display === 'none') return; // Dawn's outgoing copy
        var r = fs.querySelector('.var-options input[type="radio"]:checked');
        var t = r && r.closest('.var-option') && r.closest('.var-option').querySelector('.var-option__thumb:not(.var-option__thumb--none)');
        if (t && picks.length < 4) picks.push(t);
      });
      var sig = picks.map(function (t) { var i = t.querySelector('img'); return i ? i.getAttribute('src') : textOf(t); }).join('|');
      if (box.getAttribute('data-sig') === sig) return;
      box.setAttribute('data-sig', sig);
      while (box.firstChild) box.removeChild(box.firstChild);
      picks.forEach(function (t) { box.appendChild(t.cloneNode(true)); });
    }

    function paintText(st) {
      var txt = bar.querySelector('[data-kk-bar-txt]');
      var amount = root.querySelector('[data-kk-atc-price-amount]');
      var q = root.querySelector('.quantity__input');
      var n = q ? parseInt(q.value, 10) : 1;
      var kind, value;
      if (st && st.mode === 'atc' && root.classList.contains('kk-choice-missing')) {
        kind = 'warn'; value = copy.choice || '';
      } else if (st && st.mode === 'atc' && !st.disabled && !st.failed && amount && shown(amount)) {
        kind = 'price'; value = textOf(amount) + (n > 1 ? '|' + String(copy.qtyFormat || '').split('[n]').join(n) : '');
      } else {
        kind = 'title'; value = copy.title || '';
      }
      var sig = kind + ':' + value;
      if (txt.getAttribute('data-sig') === sig) return;
      txt.setAttribute('data-sig', sig);
      while (txt.firstChild) txt.removeChild(txt.firstChild);
      if (kind === 'price') {
        var bits = value.split('|');
        txt.appendChild(el('b', null, bits[0]));
        if (bits[1]) txt.appendChild(el('span', null, ' · ' + bits[1]));
      } else {
        txt.appendChild(el('span', kind === 'warn' ? 'kk-pdp-bar__warn' : 'kk-pdp-bar__title', value));
      }
    }

    function paint() {
      frame = 0;
      var st = state();
      if (!st) return;
      setText(bar.querySelector('[data-kk-bar-label]'), st.label);
      var mode = st.mode === 'notify' ? 'notify' : st.failed ? 'failed' : st.prompt ? 'prompt' : 'add';
      setAttr(btn, 'data-state', mode);
      var off = st.mode === 'atc' && !!st.disabled && !st.failed && !st.prompt;
      if (btn.disabled !== off) btn.disabled = off;
      setAttr(btn, 'aria-busy', st.mode === 'atc' && st.busy ? 'true' : null);
      var secondary = bar.querySelector('[data-kk-bar-notify]');
      if (secondary) { var nb = notifyBtn(); secondary.hidden = !nb || st.mode === 'notify'; if (nb) { setText(secondary, textOf(nb)); secondary.disabled = nb.disabled; } }
      paintThumbs();
      paintText(st);
    }
    function schedule() { if (!frame) frame = window.requestAnimationFrame(paint); }

    function apply() {
      var on = mq.matches && !ctaInView;
      if (bar.classList.contains('is-visible') !== on) bar.classList.toggle('is-visible', on);
      if (document.body.classList.contains('kk-pdp-bar-on') !== on) document.body.classList.toggle('kk-pdp-bar-on', on);
      if (on) {
        var h = Math.ceil(bar.getBoundingClientRect().height);
        if (h) document.documentElement.style.setProperty('--kk-pdp-bar-h', h + 'px');
      }
    }

    var secondary = bar.querySelector('[data-kk-bar-notify]');
    if (secondary) secondary.addEventListener('click', function () { var nb = notifyBtn(); if (nb) nb.click(); });
    btn.addEventListener('click', function () {
      var st = state();
      if (!st) return;
      if (st.mode === 'notify') { notifyBtn().click(); return; }
      var b = main();
      if (b && !b.disabled) b.click();
    });

    // Follow the main button, the root's state classes and the picks.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (!bar.contains(records[i].target)) { schedule(); return; }
      }
    }).observe(root, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['class', 'disabled', 'aria-busy', 'hidden', 'checked']
    });
    root.addEventListener('change', schedule);
    root.addEventListener('input', schedule);

    var fromLoad = copy.fromLoad === 'true';
    var target = root.querySelector('.kk-pdp-atc-slot') || main();
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // From load: only the button on screen hides the bar. Otherwise "in
        // view" also covers "not reached yet", so the bar waits until the
        // button has scrolled off the TOP.
        ctaInView = e.isIntersecting || (!fromLoad && e.boundingClientRect.top > 0);
        apply();
      }).observe(target);
    } else if (fromLoad) {
      ctaInView = false;
    }
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    bar.hidden = false;
    paint();
    apply();
  }

  function init() {
    if (!window.KKEl) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-kk-pdp-bar]'), bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
